import { logger } from './logger'
import { requestWithRetry } from './functions'
import * as KatalMetrics from '@amzn/katal-metrics'

export enum METHOD {
  GET = 'GET',
  POST = 'POST',
}

export const handleRequest = async (config, logMessage: string, metricsPublisher: KatalMetrics.Publisher): Promise<any> => {
  const startTime = new Date().getTime()

  logger.info(`${logMessage}, Status: requested`)
  metricsPublisher.publishCounterMonitor('request', 1)

  try {
    const response = await requestWithRetry(config)
    return {
      data: response?.data,
      status: response.status,
    }
  } catch (error: any) {
    metricsPublisher.publishCounterMonitor('error', 1)
    logger.info(`${logMessage}, Status: failed`)

    // if due to time out
    if (error.message?.includes('timeout')) {
      logger.error(`${logMessage}, error: ${error}`)
      metricsPublisher.publishCounterMonitor('timeout', 1)
    } else if (error.message?.includes('Network Error') || error.message?.includes('Request aborted')) {
      // Network error or request aborted
      logger.error(`${logMessage}, error: ${error}`)
      metricsPublisher.publishCounterMonitor('clientError', 1)
    } else {
      // non-timeout and non-network-error front end exceptions
      let message = `${error.code} `
      if (error.response) {
        message += `response: ${JSON.stringify(error.response)} `
      }
      if (error.request) {
        message += `request: ${JSON.stringify(error.request)} `
      }
      logger.fatal(`${logMessage}, error: ${message}`)
      metricsPublisher.publishCounterMonitor('fatal', 1)
    }

    return null
  } finally {
    metricsPublisher.publishTimerMonitor('time', new Date().getTime() - startTime)
  }
}
